export default "__VITE_ASSET__BnrCupIJ__"